<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <router-link
        :to="{ name: 'paciente', params: { id: data.item.idPaciente } }"
        v-if="
      $localStorageService.can('DX_14_ver_paciente') ||
        $localStorageService.can('DX_13_ver_paciente') ||
        $localStorageService.can('DX_12_ver_paciente') ||
        $localStorageService.can('DX_10_ver_paciente')
    "
    >
      <p
          v-if="
        resource.idEstatusSolicitud === 1 &&
          $localStorageService.can('DX_13_cambio_solicitud') && data.item.renegociar == true
      "
          class="letraColorAzulPrincipal letraEstiloNegrita"
      >
        {{ data["item"].nombrePaciente }}
      </p>

      <p class="letraColorAzulPrincipal letraEstiloNegrita" v-else>
        {{ data.item.nombrePaciente }}
      </p>
    </router-link>
  </div>

</template>

<script>
export default {
  name: "BandejaLinkPacienteReplicaComponente",
  props: {
    data: Object,
    resource: Object,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created(){
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
 
  },
};
</script>
